/**
 * Closing Package error code → RU message mapping (Backend CLOSING_PACKAGE_* codes).
 * Used by ERP Modal / Action Bar in later FE stages — no UI in FE-001.
 */

export type ClosingPackageErrorCode =
  | 'CLOSING_PACKAGE_APPLICATION_NOT_FOUND'
  | 'CLOSING_PACKAGE_ITEM_NOT_FOUND'
  | 'CLOSING_PACKAGE_DOCUMENT_NOT_FOUND'
  | 'CLOSING_PACKAGE_DOCUMENT_WRONG_APPLICATION'
  | 'CLOSING_PACKAGE_CARRIER_DOCUMENT_FORBIDDEN'
  | 'CLOSING_PACKAGE_LOCKED'
  | 'CLOSING_PACKAGE_ALREADY_FORMED'
  | 'CLOSING_PACKAGE_ROUTE_REQUIRED'
  | 'CLOSING_PACKAGE_ROUTE_MISMATCH'
  | 'CLOSING_PACKAGE_DOCUMENT_TYPE_MISMATCH'
  | 'CLOSING_PACKAGE_DUPLICATE_SLOT'
  | 'CLOSING_PACKAGE_ALREADY_EXCLUDED'
  | 'CLOSING_PACKAGE_NOT_EXCLUDED'
  | 'CLOSING_PACKAGE_ITEM_EXCLUDED'
  | 'CLOSING_PACKAGE_ROUTES_NOT_READY'
  | 'CLOSING_PACKAGE_COMPOSITION_EMPTY'
  | 'CLOSING_PACKAGE_REQUIRED_DOCUMENT_MISSING'
  | 'CLOSING_PACKAGE_NOT_FORMED'
  | 'CLOSING_PACKAGE_SCAN_ALREADY_DISPATCHED'
  | 'CLOSING_PACKAGE_DISPATCH_FORBIDDEN'
  | 'CLOSING_PACKAGE_SCAN_NOT_DISPATCHED'
  | 'CLOSING_PACKAGE_APPROVAL_ALREADY_REGISTERED'
  | 'CLOSING_PACKAGE_APPROVAL_FORBIDDEN'
  | 'CLOSING_PACKAGE_APPROVAL_DISPATCH_INVALID'
  | 'CLOSING_PACKAGE_NOT_LOCKED'
  | 'CLOSING_PACKAGE_REJECTION_COMMENT_REQUIRED'
  | 'CLOSING_PACKAGE_NOT_APPROVED'
  | 'CLOSING_PACKAGE_ORIGINALS_ALREADY_PREPARED'
  | 'CLOSING_PACKAGE_ORIGINALS_PREPARATION_FORBIDDEN'
  | 'CLOSING_PACKAGE_ORIGINALS_NOT_PREPARED'
  | 'CLOSING_PACKAGE_ORIGINALS_ALREADY_DISPATCHED'
  | 'CLOSING_PACKAGE_ORIGINALS_DISPATCH_FORBIDDEN'
  | 'CLOSING_PACKAGE_ORIGINALS_NOT_DISPATCHED'
  | 'CLOSING_PACKAGE_ORIGINALS_ALREADY_RECEIVED'
  | 'CLOSING_PACKAGE_RECEIPT_CONFIRM_FORBIDDEN'
  | 'CLOSING_PACKAGE_INVALID_EVENT_DATE'
  | 'CLOSING_PACKAGE_EDO_USE_DEDICATED_ENDPOINT'
  | 'CLOSING_PACKAGE_EDO_DISPATCH_FORBIDDEN'
  | 'CLOSING_PACKAGE_EDO_RECEIPT_FORBIDDEN'
  | 'CLOSING_PACKAGE_EDO_PAPER_DISPATCH_EXISTS'
  | 'CLOSING_PACKAGE_EDO_NOT_DISPATCHED'
  | 'CLOSING_PACKAGE_EDO_RESEND_COMMENT_REQUIRED'
  | 'CLOSING_PACKAGE_EDO_REVISION_COMMENT_REQUIRED'
  | 'VALIDATION_ERROR';

const CLOSING_PACKAGE_ERROR_MESSAGES: Record<ClosingPackageErrorCode, string> = {
  CLOSING_PACKAGE_APPLICATION_NOT_FOUND: 'Заявка не найдена',
  CLOSING_PACKAGE_ITEM_NOT_FOUND: 'Позиция состава не найдена',
  CLOSING_PACKAGE_DOCUMENT_NOT_FOUND: 'Документ не найден',
  CLOSING_PACKAGE_DOCUMENT_WRONG_APPLICATION: 'Документ принадлежит другой заявке',
  CLOSING_PACKAGE_CARRIER_DOCUMENT_FORBIDDEN: 'Документ перевозчика нельзя включить в комплект клиента',
  CLOSING_PACKAGE_LOCKED: 'Комплект заблокирован для изменений',
  CLOSING_PACKAGE_ALREADY_FORMED: 'Комплект уже сформирован',
  CLOSING_PACKAGE_ROUTE_REQUIRED: 'Для ТН/ТТН обязателен маршрут',
  CLOSING_PACKAGE_ROUTE_MISMATCH: 'Документ не соответствует маршруту заявки',
  CLOSING_PACKAGE_DOCUMENT_TYPE_MISMATCH: 'Документ не соответствует типу позиции',
  CLOSING_PACKAGE_DUPLICATE_SLOT: 'Позиция с таким ключом уже существует',
  CLOSING_PACKAGE_ALREADY_EXCLUDED: 'Позиция уже исключена',
  CLOSING_PACKAGE_NOT_EXCLUDED: 'Позиция не исключена',
  CLOSING_PACKAGE_ITEM_EXCLUDED: 'Нельзя заменить документ в исключённой позиции',
  CLOSING_PACKAGE_ROUTES_NOT_READY: 'Маршруты заявки не готовы для формирования комплекта',
  CLOSING_PACKAGE_COMPOSITION_EMPTY: 'Состав комплекта не создан',
  CLOSING_PACKAGE_REQUIRED_DOCUMENT_MISSING: 'Не все обязательные документы включены в комплект',
  CLOSING_PACKAGE_NOT_FORMED: 'Комплект закрывающих документов не сформирован',
  CLOSING_PACKAGE_SCAN_ALREADY_DISPATCHED: 'Сканы комплекта уже отправлены клиенту',
  CLOSING_PACKAGE_DISPATCH_FORBIDDEN: 'Отправку сканов выполняет логист',
  CLOSING_PACKAGE_SCAN_NOT_DISPATCHED: 'Сканы комплекта ещё не отправлены клиенту',
  CLOSING_PACKAGE_APPROVAL_ALREADY_REGISTERED: 'Ответ клиента по текущему циклу уже зарегистрирован',
  CLOSING_PACKAGE_APPROVAL_FORBIDDEN: 'Регистрацию ответа клиента выполняет логист',
  CLOSING_PACKAGE_APPROVAL_DISPATCH_INVALID: 'Отправка сканов не соответствует текущему циклу согласования',
  CLOSING_PACKAGE_NOT_LOCKED: 'Комплект не заблокирован — отказ клиента недоступен',
  CLOSING_PACKAGE_REJECTION_COMMENT_REQUIRED: 'Для регистрации отказа клиента обязателен комментарий',
  CLOSING_PACKAGE_NOT_APPROVED: 'Согласование клиента по текущему циклу не получено',
  CLOSING_PACKAGE_ORIGINALS_ALREADY_PREPARED: 'Оригиналы комплекта уже подготовлены',
  CLOSING_PACKAGE_ORIGINALS_PREPARATION_FORBIDDEN: 'Подготовку оригиналов выполняет бухгалтер',
  CLOSING_PACKAGE_ORIGINALS_NOT_PREPARED: 'Оригиналы комплекта ещё не подготовлены',
  CLOSING_PACKAGE_ORIGINALS_ALREADY_DISPATCHED: 'Оригиналы комплекта уже отправлены',
  CLOSING_PACKAGE_ORIGINALS_DISPATCH_FORBIDDEN: 'Отправку оригиналов выполняет бухгалтер',
  CLOSING_PACKAGE_ORIGINALS_NOT_DISPATCHED: 'Оригиналы комплекта ещё не отправлены',
  CLOSING_PACKAGE_ORIGINALS_ALREADY_RECEIVED: 'Получение оригиналов клиентом уже подтверждено',
  CLOSING_PACKAGE_RECEIPT_CONFIRM_FORBIDDEN: 'Подтверждение получения оригиналов выполняет логист',
  CLOSING_PACKAGE_INVALID_EVENT_DATE: 'Некорректная дата события',
  CLOSING_PACKAGE_EDO_USE_DEDICATED_ENDPOINT:
    'Отправку через ЭДО регистрируйте отдельной задачей, не через бумажную отправку оригиналов',
  CLOSING_PACKAGE_EDO_DISPATCH_FORBIDDEN: 'Отправку через ЭДО выполняет бухгалтер',
  CLOSING_PACKAGE_EDO_RECEIPT_FORBIDDEN: 'Подтверждение принятия в ЭДО выполняет бухгалтер',
  CLOSING_PACKAGE_EDO_PAPER_DISPATCH_EXISTS:
    'В этом цикле уже зарегистрирована бумажная отправка оригиналов',
  CLOSING_PACKAGE_EDO_NOT_DISPATCHED: 'Документы ещё не отправлены через ЭДО',
  CLOSING_PACKAGE_EDO_RESEND_COMMENT_REQUIRED:
    'Для повторной отправки через ЭДО обязателен комментарий',
  CLOSING_PACKAGE_EDO_REVISION_COMMENT_REQUIRED:
    'Для исправления комплекта по ЭДО обязателен комментарий',
  VALIDATION_ERROR: 'Ошибка валидации запроса',
};

export function isClosingPackageErrorCode(value: unknown): value is ClosingPackageErrorCode {
  return typeof value === 'string' && value in CLOSING_PACKAGE_ERROR_MESSAGES;
}

export function mapClosingPackageErrorCode(code: string | null | undefined, fallback?: string): string {
  if (code && isClosingPackageErrorCode(code)) {
    return CLOSING_PACKAGE_ERROR_MESSAGES[code];
  }
  return fallback || 'Ошибка операции с комплектом закрывающих документов';
}

/** Extract RU message from RTK / fetch error payload shape. */
export function mapClosingPackageApiError(error: unknown, fallback?: string): string {
  const err = error as {
    data?: { code?: string; error?: string; message?: string };
    error?: string;
    message?: string;
  } | null;

  const code = err?.data?.code;
  if (code && isClosingPackageErrorCode(code)) {
    return CLOSING_PACKAGE_ERROR_MESSAGES[code];
  }

  const message = err?.data?.error || err?.data?.message || err?.error || err?.message;
  if (typeof message === 'string' && message.trim()) {
    return message.trim();
  }

  return fallback || 'Ошибка операции с комплектом закрывающих документов';
}
